import {udSentry} from '@udemy/sentry';
import {udApi} from '@udemy/ud-api';

/**
 * Checks if the current user is subscribed to all specified courses
 * @param courseIds - Array of course IDs to check subscription for
 * @returns Promise<boolean> - Returns true only if user is subscribed to all courses
 */
export const checkCourseSubscription = async (courseIds: number[]): Promise<boolean> => {
    try {
        const promises = courseIds.map((courseId) =>
            udApi.get(`/courses/${courseId}/`, {
                params: {
                    'fields[course]': 'is_user_subscribed',
                },
            }),
        );

        const responses = await Promise.all(promises);

        const areAllSubscribed = responses.every(
            (response) => response.data.is_user_subscribed === true,
        );
        return areAllSubscribed;
    } catch (error) {
        udSentry.captureException(error);
        return false;
    }
};
